import { useContext } from 'react'

import { Link } from 'tools/Link'
import { MaxViewPage } from 'tools/Uniform'

import { SITEMAP, TABS } from 'libreon/routes'
import GlobalContext from 'reducer/global'

import { StatefulLink, useVisible } from '../Tools'

function styledClasses({ styled, fg, color }) {
  if (styled) {
    fg = fg ? ' fg-' + fg : ''
    return `priority bg-${color} b--${color}${fg}`
  }
  return ''
}

export function NavTabs() {
  const [{ page }] = useContext(GlobalContext)
  const { navId, subId } = page

  if (!navId) return <div className="mr-auto" />

  // debugging: verify it is valid, even where we don't use the result
  // getNavPoint(navId)

  const hasTabs = TABS[navId]?.items?.length > 0
  let activeClass

  // colorize the upper tab like the lower subtab bar; requires 'active' set
  // in the subtab, even if only a " " string
  if (subId && SITEMAP[subId].nav.styled) {
    activeClass = styledClasses(SITEMAP[subId].nav)
  }

  return (
    hasTabs && (
      <GenerateTabs navId={navId} subId={subId} activeClass={activeClass} />
    )
  )
}

////////////////////////////////////////////////////////////////////////////////

function GenerateTabs({ navId, activeClass, subId, type = 'tab' }) {
  const tabs = TABS[navId]
  if (!tabs) throw new Error('Unable to find tabs for navId=' + navId)

  const visible = useVisible(tabs.items, subId || 'nav')

  return (
    <div className="flex items-end gh3 navtabs">
      {visible.map(({ id, args }) => (
        <StatefulLink
          key={id}
          navId={id}
          tabData={args}
          name={SITEMAP[id][type](args)}
          innerClass=""
          activeClass={activeClass}
          className="button clear tab pv1 dib"
          navTab={true}
        />
      ))}
    </div>
  )
}

////////////////////////////////////////////////////////////////////////////////
export function SubTabs({ children, title, navId, view, avatar, avatarWidth }) {
  if (!children) {
    if (title !== false) {
      if (title) {
        children = title
      } else {
        children = <>&nbsp;</>
      }
    }
  }

  return (
    <div className="bg-neutral bt b--transparent">
      <MaxViewPage mv=" " className="flex-items relative">
        <div>
          <div className="flex-items relative f5 accent mt3 mb2 fw6 w-100">
            {children}
          </div>
          <div className="w-100 f2 flex gh4">
            <GenerateTabs navId={navId} type="subTab" />
          </div>
        </div>
        {view && (
          <div className="flex-items flex-grow-1">
            <Link
              className="ml-auto flex-items medium gh2 button f1 fw4"
              to={view}
            >
              <i className="fas fa-chevron-left" />
              View
              {avatar}
            </Link>
          </div>
        )}
      </MaxViewPage>
    </div>
  )
}
/*
<div className="button clear absolute top-0 right-0 mt1n">
  <ProjectAvatar avatar={project.avatar} size="thumb" />
</div>
*/
